<template>
    <div class="video-shopping">
        <ul>
            <video-shopping-item 
                v-for="item in list"
                :key="item.id"
                :item="item"
            />
        </ul>
    </div>
</template>
<script>
import VideoShoppingItem from './video-shopping-item';
export default {
    components: {
        VideoShoppingItem
    },
    props: {
        list: Array
    }
};
</script>
<style lang="less" scoped>
    img {
        display: block;
    }
    ul {
        width: 327px;
        margin: 0 auto;
    }
</style>
